import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { FormattedNumber } from 'react-intl'

import {
    sendHoverSoundCommand,
    sendClickSoundCommand,
} from 'react-wot-bootstrap'

import RatingLabelTooltip from '../RatingLabelTooltip/RatingLabelTooltip.jsx'

import styles from './RatingLabel.scss'

export default class RatingLabel extends React.Component{
    static propTypes = {
        elo: PropTypes.number.isRequired,
        position: PropTypes.number,
        vehicle_level: PropTypes.number.isRequired,
        show_leaderboard: PropTypes.bool,
        onClick: PropTypes.func.isRequired,
    }

    constructor() {
        super()

        this.onClick = this.onClick.bind(this)
    }

    onClick() {
        if (this.props.show_leaderboard) {
            this.props.onClick()
            sendClickSoundCommand()
        }
    }

    render() {
        const tooltipId = `RatingLabelTooltip${this.props.vehicle_level}`

        const className = classNames(styles.base, {
            [styles.isDisabled]: !this.props.show_leaderboard,
        })
        const iconClassName = classNames(styles.vehicleLevelIcon, styles[`level-${this.props.vehicle_level}`])

        return (
            <div
                className={className}
                data-tip data-for={tooltipId}
                onClick={this.onClick}
                onMouseEnter={sendHoverSoundCommand}
            >
                <div className={iconClassName}></div>
                <FormattedNumber value={this.props.elo} />
                <RatingLabelTooltip id={tooltipId} {...this.props}/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./containers/Stronghold/components/RatingLabel/RatingLabel.jsx